<template>
  <footer class="c-footer footer">
    <div class="footer__content" v-show="lang !== 'kr'">
      <div class="content__arrow-rotation">
        <svg width="9px" height="13px" viewBox="0 0 9 13">
          <polygon points="6.87061285 0.5 8.5 2.15785589 3.89355686 6.5029906 8.5 10.8421537 6.87061285 12.5 1.38208486 7.32892603 0.5 6.5029906 1.38208486 5.6710778"></polygon>
        </svg>
      </div>
      <div class="content__text" v-if="inapp && !infullpage">
        <span v-html="$translate('SHOP_THE_COLLECTION')"></span>
      </div>
      <a
        class="content__text"
        :href="campaignUrl"
        target="_blank"
        rel="noopener"
        v-else
      >
        <span v-html="$translate('SHOP_THE_COLLECTION')"></span>
      </a>
    </div>

    <img
      class="footer__croccat"
      src="/img/illustrations/croccat_desktop.gif"
      alt="Gucci crocodile cat"
    >

    <AppAudio :muted="muted" />
  </footer>
</template>

<script>
import { utm, build } from 'url-utm-params';
import AppAudio from '@/components/AppAudio.vue';
import { getLang, inApp, inFullpage } from '../scripts/utils';

export default {
  name: 'AppFooter',

  components: {
    AppAudio,
  },

  props: {
    muted: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      lang: getLang(),
      inapp: inApp(),
      infullpage: inFullpage(),
    };
  },

  computed: {
    campaignUrl() {
      const link = 'https://yukocapsule.gucci.com/collection';
      const defaults = {
        utm_campaign: 'yukohiguchi_catalog',
        utm_content: 'yukohiguchi_catalog',
        utm_medium: 'catalog',
        utm_source: 'yukohiguchi_catalog',
        utm_term: 'yukohiguchi_catalog',
      };
      const parsed = utm(document.location.href);

      return build(link, { ...defaults, ...parsed }, false);
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  position: fixed;
  left: 0;
  bottom: $unit-vh;
  width: 100%;

  display: grid;
  grid-template-columns: repeat(16, 1fr);

  font-weight: 300;
  pointer-events: none;

  @include mq($until: ipadL) {
    padding: 0 20px;
    bottom: 20px;
  }

  @include mq($until: mobileX) {
    bottom: 10px;
  }

  > * {
    align-self: end;
  }

  &__content {
    grid-column: 1 / 10;
    justify-self: start;

    font-size: 12px;
    pointer-events: all;
    line-height: 1.5;

    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-flow: row;
    text-align: left;

    padding-bottom: 20px;

    @include mq(ipadP) {
      align-items: center;
    }

    @include mq(ipadL) {
      grid-column: 2 / 8;
      font-size: 14px;
      padding-bottom: 0;
    }

    .content__arrow-rotation {
      display: inline-block;
      position: relative;
    }

    svg {
      display: inline-block;
      width: 14px;
      margin: -2px 0 0 0;

      transform: scaleX(-1);
      fill: $color-black;
      transition: margin 0.2s $inOutSine,
        fill 0.2s $inOutSine;
    }

    .content__text {
      position: relative;
      display: inline-block;

      line-height: 1.3;
      font-weight: 500;
      color: rgba($color-text, 0.9);
      margin-left: 10px;
      transition: color 0.2s $inOutSine,
        margin 0.2s $inOutSine;

      span.alternate {
        position: absolute;
        top: 100%;
        left: 0px;
        opacity: 0.2;

        @include mq($until: ipadL) {
          display: none;
        }
      }

      @include mq(ipadL) {
        font-size: 12px;
      }
    }

    @include mq($and: $is-not-touch-device) {
      &:hover {
        svg {
          margin-left: 5px;
          fill: $color-beige;
        }

        .content__text {
          color: $color-beige;
          margin-left: 7px;
        }
      }
    }
  }

  &__croccat {
    position: relative;
    top: 0px;
    grid-column: 10 / 15;
    width: $unit-vw * 10;
    justify-self: end;
    margin: 0;

    @include mq($until: mobile) {
      padding-left: 18px;
    }
    @include mq($and: $is-iphoneSmall) {
      padding-left: 18px;
    }

    @include mq(ipadL) {
      top: 15px;
      grid-column: 10 / 16;
      width: $unit-vw * 5;
    }
  }

  .app-audio {
    grid-column: 16 / -1;
    margin-bottom: 27px;

    @include mq($from: mobileX, $until: ipadL) {
      margin-bottom: 15;
    }

    @include mq(ipadL) {
      margin-bottom: 6px;
    }

    @include mq(d) {
      margin-bottom: 8px;
    }
  }

  @at-root .in-app:not(.in-fullpage) .footer {
    .content__arrow-rotation {
      transform: rotate(90deg);
      transform-origin: center center;

      img {
        margin: 0px;
      }
    }
  }
}
</style>
